export const LINE_BOT_GROUP_SUPPORT = ['105890078699861']



// WEBPACK FOOTER //
// ./src/constants/line-bot-group.js